import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/authProvider";
import GMTIcon from "../../../img/svg/gmtIcon";
import { ArrowLeftIcon } from "../../../img/svg/adminIcons";
import SideField from "./sideField";
import { getAdminNav } from "./adminNav";

// conteúdo do menu do painel: usado fixo no desktop (adminLayout) e dentro do drawer no mobile (adminHeader)
export default function SideBar({ onNavigate }: { onNavigate?: () => void }) {

    const { user } = useAuth();
    const pathname = useLocation().pathname.split("/")[2];

    const sections = getAdminNav(user?.roles);

    return (
        <div className="flex h-full flex-col bg-primary text-gray-300">
            <div className="flex h-16 shrink-0 items-center gap-3 px-5 border-b border-white/10">
                <Link to="/admin" onClick={onNavigate} aria-label="Início do painel">
                    <GMTIcon width="96px" fill="#fff" />
                </Link>
                <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-secondary">Painel</span>
            </div>

            <nav className="flex-1 overflow-y-auto px-3 py-4">
                {
                    sections.map((section, sIdx) => (
                        <div key={sIdx} className={sIdx > 0 ? "mt-6" : ""}>
                            {
                                section.title ?
                                    <p className="px-3 mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500">{section.title}</p>
                                    : null
                            }
                            <ul className="flex flex-col gap-0.5">
                                {
                                    section.items.map(item => (
                                        <li key={item.to}>
                                            <SideField
                                                to={item.to}
                                                icon={item.icon}
                                                label={item.label}
                                                selected={item.segment === "" ? [undefined, ""].includes(pathname) : pathname === item.segment}
                                                onClick={onNavigate}
                                            />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    ))
                }
            </nav>

            <div className="shrink-0 border-t border-white/10 p-3">
                <div className="flex items-center gap-3 px-3 py-2">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary text-sm font-bold uppercase text-white">
                        {(user?.name || user?.email || "?").charAt(0)}
                    </span>
                    <div className="min-w-0">
                        {
                            user?.name ?
                                <p className="truncate text-sm font-semibold text-white">{user.name}</p>
                                : null
                        }
                        <p className="truncate text-xs text-gray-400">{user?.email}</p>
                    </div>
                </div>
                <SideField to="/" icon={<ArrowLeftIcon />} label="Voltar para o site" onClick={onNavigate} />
            </div>
        </div>
    )
}
